import { Controller } from '@hotwired/stimulus'

// Mostra o elemento depois de um tempo (ex.: "Já pagou?" após 2 min no Pix).
export default class extends Controller {
  static values = { depois: { type: Number, default: 120000 } }

  connect() { this.timer = setTimeout(() => { this.element.hidden = false }, this.depoisValue) }

  disconnect() { clearTimeout(this.timer) }
}
